var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view',{staticClass:"mt-2"}),_c('v-footer',{attrs:{"padless":"","color":"grey lighten-2"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v(_vm._s(_vm.company))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }